import React from "react";
import { Link } from "react-router-dom";

const LoginSignupWrapper = ({ children }) => {
  return (
    <div className="container-fluid auth-login-signup-main bg-common">
      <div className="row mx-0 login-inner-row">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 auth-login-details">
          <div className="container">{children}</div>
        </div>
        <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 d-md-none d-lg-none d-xl-block auth-right-banner">
          <img
            src="/assets/images/auth-right-banner.png"
            alt=""
            className="img-fluid d-none d-sm-block d-md-block d-lg-block d-xl-block"
          />
          <img
            src="/assets/images/auth-banner-mob-img.svg"
            alt=""
            className="img-fluid d-block d-sm-none d-md-none d-lg-none d-xl-none"
          />
          <div className="logo-mobile-div">
            <Link to="/">
              <img
                src="/assets/images/icons/logo-favicon.svg"
                alt=""
                className="img-fluid"
              />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginSignupWrapper;
